import { Box, Paper, Typography } from '@mui/material';
import { Fragment } from 'react';

export default function Support(): JSX.Element {
  return (
    <Fragment>
      {/* <Paper elevation={3}>
        <Box sx={{ width: '50%', maxWidth: 500 }}> */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '90vh' }}>
        <Paper elevation={3} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '80%', height: '60vh' }}>
          <Box sx={{ width: '69%' }}>
            <Typography variant='subtitle1' gutterBottom>
              Support Options
            </Typography>
            <Typography variant='subtitle2' gutterBottom>
              For general support on the operation and functionality of the E-ULD app, please contact one of the below parties:
              <p style={{ paddingLeft: 10 }}>
                - Unilode System Support: cantrack@unilode.com
                <br />- your assigned Customer Success Manager for Unilode Aviation Solutions
              </p>
            </Typography>
            <Typography variant='subtitle2' gutterBottom></Typography>

            <Typography variant='subtitle1' gutterBottom>
              Account Deletion
            </Typography>

            <Typography variant='body2' gutterBottom>
              If you wish to remove your account and all personal data associated with it, either use the &apos;Delete Account&apos; link in the
              Setting Menu of the E-ULD App or contact the following support support email: <br />
              cantrack@unilode.com
            </Typography>
            <br />
          </Box>
        </Paper>
      </div>
    </Fragment>
  );
}
